import { struct } from 'io-ts/Decoder';

import { Area } from '../../../../ui/geometry/Area';

export const Request = struct({
	area: Area,
});
